<div class="ui-select">
  @if (label) {
    <label class="ui-select__label" [for]="id">{{ label }}</label>
  }

  <select
    class="ui-select__control"
    [id]="id"
    [disabled]="disabled"
    [value]="value"
    (change)="onChangeSelection($event)"
    (blur)="onBlur()"
  >
    <option value="" disabled>{{ placeholder }}</option>
    @for (option of options; track option.value) {
      <option [value]="option.value">{{ option.label }}</option>
    }
  </select>

  @if (hint && !error) {
    <p class="ui-select__hint">{{ hint }}</p>
  }

  @if (error) {
    <p class="ui-select__error">{{ error }}</p>
  }
</div>
